import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private theme: string;

  private themeListener = new Subject<string>();

  getThemeListener() {
    return this.themeListener.asObservable();
  }

  constructor() {
    this.theme = environment.theme;
  }

  getTheme() {
    this.themeListener.next(this.theme)
    return this.theme;
  }

  setTheme(theme: string) {
    this.themeListener.next(theme)
    this.theme = theme;
  }

  getOrLoadTheme() {
    if (this.theme) {
      this.themeListener.next(this.theme)
    } else {
      this.getTheme()
    }
  }
}
